'use client';

import { Flex, freddyTheme, ReviewRating, Typography } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';

const ReviewDescription = ({ value, count }: { value: string; count: number }) => {
  const reviewRatingTranslations = useFreddyTranslations('reviewRating');
  const { t } = useTranslation('webshop.filterPage.facets');

  const reviewRatingValue = Number(value || 0) * 2;
  const shouldShowMoreText = Number(value) < 5;

  return value !== '0' ? (
    <Flex wrap={{ md: 'wrap' }}>
      <ReviewRating
        translations={reviewRatingTranslations}
        value={reviewRatingValue}
        scoreDisplay='none'
        size='small'
        sx={{ alignSelf: 'center', '& > div': { gap: `${freddyTheme.spacing[100]} !important` } }}
      />
      {shouldShowMoreText && (
        <Typography component='span' pr={100}>
          {t('andMore')}
        </Typography>
      )}
      <Typography component='span' color='additional' fontSize='sm'>
        ({count})
      </Typography>
    </Flex>
  ) : (
    <Typography component='span'>{t('showAll')}</Typography>
  );
};

export { ReviewDescription };
